//import { KEYPADS_DEFAULT_END, KEYPADS_DEFAULT_START } from "../conf/mtma-keypads";

export class MtmaKeypad {
    Description: string;
    Code: string;
    ObjId: string;
    Actions: number[];
    RuleId: number;
    DtFrom: string;
    DtTo: string;
    RuleName: string;
    Valid: boolean;
    constructor() {
        //this.DtFrom = KEYPADS_DEFAULT_START;
        //this.DtTo = KEYPADS_DEFAULT_END;
        this.Actions = [255, 255];
    }
}
